import { render, staticRenderFns } from "./VideoCallSubScreenGridItem.vue?vue&type=template&id=c0034f86&scoped=true&"
import script from "./VideoCallSubScreenGridItem.vue?vue&type=script&lang=ts&"
export * from "./VideoCallSubScreenGridItem.vue?vue&type=script&lang=ts&"
import style0 from "./VideoCallSubScreenGridItem.vue?vue&type=style&index=0&id=c0034f86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0034f86",
  null
  
)

export default component.exports